import Component from '../core/Component';
import Ajax from '../core/Ajax';
import Form from '../services/Form'
import FoxentryValidation from '../services/FoxentryValidation';

export default class CountriesSubForm extends Component {
    constructor(element) {
        super(element);

        this.ref = {
            btn: null,
			emailInput: null,
			errorMessage: null
        };
    }

    prepare() {
        this.element.addEventListener('submit', ::this.handleSubmit);
    }

    openSuccessModal() {
        let modalElement = document.getElementById('modal-form-success');

        const modal  = Component.getFromElement(modalElement);

        modal.open();
    }

    handleSubmit(event) {
		const onSuccess = () => {
			// Call after foxentry validation success

			const url = this.element.getAttribute('action');
			let form = new Form(this.element);
			let formFields = form.getFieldsObject();

			let ajax = new Ajax();
			ajax.post(url, formFields, ::this.onSuccess);
		};
		const onFailed = () => {
			// Call after foxentry validation fail

			this.removeButtonLoading();
		};

		this.addButtonLoading();

		const formElem = this.element;
		const foxentryValidation = new FoxentryValidation(formElem);
		foxentryValidation.validate(onSuccess, onFailed);

        event.preventDefault();
    }

    onSuccess(result, contentType) {
        let jsonResult = JSON.parse(result);

        if (jsonResult.success === true) {
			this.openSuccessModal();

			this.ref.emailInput.value = '';
			this.removeButtonLoading();
			this.ref.errorMessage.classList.add('u-hidden');
		} else {
			this.onError(jsonResult?.message);
		}

    }

    onError(message) {
		const errorMessage = this.ref.errorMessage;
		const errorContent = errorMessage.getElementsByTagName('p')[0] ?? null;

		if (errorContent) {
			errorContent.innerText = message;
			errorMessage.classList.remove('u-hidden');
		}

		this.removeButtonLoading();

		console.warn('Form not submitted');
    }

	addButtonLoading() {
		this.ref.btn.classList.add('btn-is-loading');
		this.ref.btn.disabled = true;
	}

	removeButtonLoading() {
		this.ref.btn.classList.remove('btn-is-loading');
		this.ref.btn.removeAttribute('disabled');
	}
}
